var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canBeDriven)?_c('span',[_c('button',{staticClass:"settingBtn",attrs:{"type":"button"},on:{"click":_vm.onOpenEditGridLayoutModal}},[_vm._v(" "+_vm._s(_vm.$t('SETTING'))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }